/* eslint-disable*/

import React from "react";

import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Button,
  TextField,
  Typography,
  Paper,
  AppBar,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Toolbar,
  Tooltip,
} from "@material-ui/core";
import { SearchIcon } from "@chakra-ui/icons";
import RefreshIcon from "@material-ui/icons/Refresh";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import { Pagination } from "@material-ui/lab";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import {
  getAllRoles,
  paginateRoles,
  getRole,
} from "../../utils/store/actions/roles.actions";
import { getUserRoles } from "../../utils/store/actions/users.actions";

const styles = (theme: Theme) =>
  createStyles({
    paper: {
      backgroundColor: "white",
      maxWidth: "90%",
      margin: "auto",
      marginTop: "5%",
      overflow: "hidden",
    },
    searchBar: {
      backgroundColor: "#F5F6FF",
      borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    },
    searchInput: {
      backgroundColor: "#F5F6FF",
      fontSize: theme.typography.fontSize,
    },
    block: {
      display: "block",
    },
    addUser: {
      marginRight: theme.spacing(1),
    },
    contentWrapper: {
      margin: "40px 16px",
    },
  });
class UsersRules extends React.PureComponent<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      totalItems: 0,
      totalPages: 0,
      cureentPage: 1,
      load: false,
    };
  }

  componentDidMount() {
    this.props.getAllRoles();
  }

  editRole = (role: any) => {
    this.props.getRole(role.id);
    window.location.href = `/admin/role/?id=${role.id}`;
  };
  handleChange = (e: any, value: number) => {
    this.props.paginateRoles(value);
  };
  render() {
    const { classes, Roles, t } = this.props;
    const disabledButton =
      (this.props.Users?.get_properties || [])?.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
        ? true
        : !(
            this.props.LocalUser &&
            this.props.LocalUser.role &&
            this.props.LocalUser.role.userCanCreate
          );
    const isSupervisor =
      (this.props.Users?.get_properties || [])?.find(
        (property: { key: string; value: boolean }) =>
          property.key === "IS_V4_AVAILABLE"
      )?.value === "true"
        ? false
        : this.props.LocalUser.role.adminCanEditProduct &&
          this.props.LocalUser.role.adminCanEditDocuments &&
          this.props.LocalUser.role.adminCanEditRisk &&
          this.props.LocalUser.role.adminCanEditConfiguration;
    return (
      <>
        {/* Page content */}
        <Paper className={classes.paper}>
          <AppBar
            className={classes.searchBar}
            position="static"
            color="default"
            elevation={0}
          >
            <Toolbar>
              <Grid container spacing={2} alignItems="center">
                <Grid item>
                  <SearchIcon className={classes.block} color="inherit" />
                </Grid>
                <Grid item xs>
                  <TextField
                    fullWidth
                    placeholder={t("SEARCH_BY_NAME")}
                    InputProps={{
                      disableUnderline: true,
                      className: classes.searchInput,
                    }}
                  />
                </Grid>
                <Grid item>
                  <Tooltip title="Reload">
                    <IconButton onClick={this.props.getAllRoles}>
                      <RefreshIcon className={classes.block} color="inherit" />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
          <div className={classes.contentWrapper}>
            {Roles ? (
              <>
                <List>
                  {Roles.roles.content.map((role: any) => {
                    return role.role === "SUPERVISOR" && !isSupervisor ? (
                      false
                    ) : (
                      <div key={role.id}>
                        <ListItem>
                          <ListItemAvatar>
                            <AccountBoxIcon style={{ color: "ae0064" }} />
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <div className={classes.truncate}>
                                <strong>
                                  {t(role ? role.role : "Anonymous")}
                                </strong>
                              </div>
                            }
                          />
                          <Button
                            disabled={disabledButton}
                            onClick={() => this.editRole(role)}
                            style={{ color: "ae0064", textTransform: "none" }}
                          >
                            {t("EDIT")}
                          </Button>
                        </ListItem>
                        <Divider />
                      </div>
                    );
                  })}
                </List>
                <Pagination
                  count={Roles.roles.totalPages}
                  page={Roles.roles.number + 1}
                  onChange={this.handleChange}
                />
              </>
            ) : (
              <>
                <Typography color="textSecondary" align="center">
                  {t("NO_ROLES")}
                </Typography>
              </>
            )}
          </div>
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state: {
  Roles: RolesState;
  LocalUser: LocalUserState;
}) => ({
  Roles: state.Roles,
  LocalUser: state.LocalUser,
});

const mapDispatchToProps = {
  getAllRoles,
  paginateRoles,
  getRole,
  getUserRoles,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(UsersRules)));
